/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../components/ServicesLayout';
import Panel from './Panel';
import UserInfo from '../userInfo/UserInfo';
import MojeDokumenty from '../mojeDokumenty/MojeDokumenty';
import DeleteAccount from '../DeleteAccount/index.js';
import ConfirmDelete from '../ConfirmDelete/index.js';
import MyMessages from '../MyMessages/index.js';
import MessageDetail from '../MessageDetail/index.js';
import StatusGmin from '../StatusGmin/StatusGmin.js';

const title = 'Panel użytkownika';

export default {
  path: '/panel',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return { redirect: `/panel/${state.user.username}` };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };

        // return {
        //   title,
        //   component: <ServicesLayout><Panel title={title} /></ServicesLayout>,
        // };
      },
    },
    {
      path: '/:username',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="moje_dane" sidePanel>
                <UserInfo userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    {
      path: '/:username/mojedokumenty',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="dokumenty" sidePanel>
                <MojeDokumenty userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    {
      path: '/:username/usunkonto',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="usun_konto" sidePanel>
                <DeleteAccount userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    {
      path: '/potwierdz/:username/:token',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout sidePanel>
                <ConfirmDelete
                  userData={state.user}
                  login={ctx.params.username}
                  token={ctx.params.token}
                />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    {
      path: '/:username/mojezapytania',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="moje_zapytania" sidePanel>
                <MyMessages userData={state.user} login={ctx.params.username} />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    { 
      path: '/:username/statusgmin',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="status_gmin" sidePanel>
                <StatusGmin userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
    {
      path: '/:username/zapytanie/:id',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout sidePanel>
                <MessageDetail
                  userData={state.user}
                  login={ctx.params.username}
                  id={ctx.params.id}
                />
              </ServicesLayout>
            ),
          };
        }
        return { redirect: process.env.LOGIN_ENDPOINT };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/panel/index.js